export const API_GATEWAY_BASE_URL = import.meta.env.VITE_HOST_API;
